/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description mutate hook to delete code tenant data
 */

import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

interface IProps {
	codeId: string;
	reaction?: string[];
	note?: string[];
}

const useDeleteCodeTenantData = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ codeId, reaction, note }: IProps) => {
			await api.CodeExplorerTenantDataApi.deleteCodeTenantData({ codeId, reaction, note });
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.codeTenantData] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteCodeTenantData;
